/**
 * @generated SignedSource<<d7aa09aa29354220a79c91e7d74f6e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type portalDropdown_AtlassianHubAppShell$data = {
  readonly portals: {
    readonly portalsList: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
    }> | null;
  } | null;
  readonly " $fragmentType": "portalDropdown_AtlassianHubAppShell";
};
export type portalDropdown_AtlassianHubAppShell$key = {
  readonly " $data"?: portalDropdown_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"portalDropdown_AtlassianHubAppShell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "portalsFilter"
    }
  ],
  "kind": "Fragment",
  "name": "portalDropdown_AtlassianHubAppShell",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "portalsFilter",
          "variableName": "portalsFilter"
        }
      ],
      "concreteType": "HelpCenterPortals",
      "kind": "LinkedField",
      "name": "portals",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterPortal",
          "kind": "LinkedField",
          "name": "portalsList",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "99e96001b0845815b25025bb6c70250a";

export default node;
